var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mask-side-section-container",
    { attrs: { title: _vm.sectionTitle } },
    [
      _c(
        "v-flex",
        {
          staticClass: "scroll-fire-fox",
          staticStyle: { height: "100%", overflow: "auto" },
          attrs: { shrink: "" }
        },
        [
          _c("div", { staticStyle: { margin: "4px 20px" } }, [
            _vm._v(
              "\n      To stop the current duct entry action, click on the selected duct entry\n      to deselect it or selected another duct entry\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48bd1378", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48bd1378","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryAction.vue
// module id = null
// module chunks = 